module.exports = __webpack_public_path__ + "media/images/Hébergements eco-responsables-2b7648dddbb1963d708ff36b0f2c1d76.svg";